/**
 * @fileoverview Item types the UEP supports
 */
goog.declareModuleId('yext.ui.components.entitypicker.container.itemtypes');

export const ItemTypes = Object.freeze({
  ENTITIES: 'UEP_CART_ENTITIES',
  FOLDERS: 'UEP_CART_FOLDERS',
  LABELS: 'UEP_CART_LABELS',
  ENTITYTYPES: 'UEP_CART_ENTITYTYPES',
});
